<template>
  <div class="register-page">
    <Backbar
      :title="$t('editProfile.title')"
      is-clean
      @onBackClick="$router.go(-1)"
    />
    <div class="register-form">
      <ValidationObserver ref="registerForm">
        <div class="">
          <ValidationProvider
            rules="required"
            name="firstName"
            v-slot="{ errors }"
          >
          <Input :placeholder="$t('registerPage.firstName')" v-model="registration.firstName"/>
          <span class="error">{{ errors[0] }}</span>
        </ValidationProvider>
        </div>
        <div class="has-margin-top-25">
          <ValidationProvider
            rules="required"
            name="lastName"
            v-slot="{ errors }"
          >
            <Input :placeholder="$t('registerPage.lastName')" v-model="registration.lastName"/>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="has-margin-top-25">
          <ValidationProvider
            rules="required|min:12"
            name="mobile"
            v-slot="{ errors }"
          >
            <MaskInput
              data-vv-validate-on="change"
              :placeholder="$t('registerPage.phoneNumber')"
              v-model="registration.mobile"
              :mask="'###-###-####'" />
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="has-text-black87 _fs-14 has-margin-top-25">{{$t('registerPage.gender')}}</div>
        <div class="has-margin-top-15">
          <ValidationProvider
            rules="required"
            name="gender"
            v-slot="{ errors }"
          >
            <div class="is-flex is-flex-wrap-wrap">
              <RadioButton
                v-model="registration.gender"
                name="gender"
                native-value="Male">
                {{$t('registerPage.male')}}
              </RadioButton>
              <RadioButton
                v-model="registration.gender"
                name="gender"
                native-value="Female">
                {{$t('registerPage.female')}}
              </RadioButton>
              <RadioButton
                v-model="registration.gender"
                name="gender"
                native-value="Prefer not to say">
                {{$t('registerPage.preferNotToSay')}}
              </RadioButton>
            </div>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="has-text-black87 _fs-14 has-margin-top-25">{{$t('registerPage.dateOfBirth')}}</div>
        <div class="has-margin-top-15">
          <ValidationProvider
            rules="required"
            name="birthDate"
            v-slot="{ errors }"
          >
          <DropdownDatePicker v-model="registration.birthDate" :defaultDate="registration.birthDate" required/>
          <span class="error">{{ errors[0] }}</span>
        </ValidationProvider>
        </div>
        <div class="has-text-black87 _fs-14 has-margin-top-25">{{$t('registerPage.address')}}</div>
        <div class="has-margin-top-20">
          <ValidationProvider
            name="address"
            v-slot="{ errors }"
          >
            <Input :placeholder="$t('registerPage.addressDetail')" v-model="registration.address"/>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="has-margin-top-15">
          <ValidationProvider
            name="province"
            v-slot="{ errors }"
          >
            <SelectProvince :placeholder="$t('registerPage.province')" v-model="provinceId" @change="onProvinceChange">
              <option v-for="(province, index) in provinces" :key="index" :value="province.id">
                {{ $i18n.locale === 'th' ? province.name_th : province.name_en }}
              </option>
            </SelectProvince>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="has-margin-top-15">
          <ValidationProvider
            name="district"
            v-slot="{ errors }"
          >
            <SelectProvince :placeholder="$t('registerPage.district')" v-model="districtId" @change="onDistrictChange">
              <option v-for="(district, index) in districts" :key="index" :value="district.id">
                 {{ $i18n.locale === 'th' ? district.name_th : district.name_en }}
              </option>
            </SelectProvince>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="has-margin-top-15">
          <ValidationProvider
            name="subDistrict"
            v-slot="{ errors }"
          >
           <SelectProvince :placeholder="$t('registerPage.subDistrict')" v-model="subDistrictId" @change="onSubDistrictChange">
             <option v-for="(subDistrict, index) in subDistricts" :key="index" :value="subDistrict.id">
              {{ $i18n.locale === 'th' ? subDistrict.name_th : subDistrict.name_en }}
            </option>
           </SelectProvince>
          <span class="error">{{ errors[0] }}</span>
        </ValidationProvider>
        </div>
        <div class="has-margin-top-15">
          <ValidationProvider
            name="postcode"
            v-slot="{ errors }"
          >
            <MaskInput :placeholder="$t('registerPage.postcode')" v-model="registration.postCode" :mask="'#####'"/>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="has-text-black87 _fs-14 has-margin-top-25">{{$t('registerPage.healthCondition')}}</div>
        <div class="has-margin-top-15">
          <AnswerList
            v-model="healthProblems"
          />
        </div>
        <ValidationProvider
          :rules="{'required': isOtherHealthProblem}"
          name="otherHealthProblem"
          v-slot="{ errors }"
        >
          <div class="has-margin-top-5" v-show="isOtherHealthProblem">
            <Input placeholder="Other" v-model="otherHealthProblem"/>
            <span class="error">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
        <div class="has-text-black87 _fs-14 has-margin-top-25">{{$t('registerPage.interestHealthcare')}}</div>
        <div class="has-margin-top-15">
          <AnswerList
            v-model="healthInteresting"
          />
        </div>
        <ValidationProvider
            :rules="{'required': isOtherHealthInteresting}"
            name="otherHealthInteresting"
            v-slot="{ errors }"
          >
          <div class="has-margin-top-5" v-show="isOtherHealthInteresting">
            <Input placeholder="Other" v-model="otherHealthInteresting"/>
            <span class="error">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </ValidationObserver>
      <div class="has-margin-top-15">
        <div class="is-flex align-items-center justify-center has-margin-top-10">
          <RoundButton @click="submit">{{$t('editProfile.finishEditing')}}</RoundButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import humps from 'humps'
import StringMask from 'string-mask'
import liff from '@line/liff'

import jsonProvinces from '@/data/provinces.json'
import jsonDistricts from '@/data/districts.json'
import jsonSubDistricts from '@/data/sub_districts.json'

import Backbar from '@/components/Backbar.vue'
import Input from '@/components/base/Input.vue'
import MaskInput from '@/components/base/MaskInput.vue'
import AnswerList from '@/components/AnswerList.vue'
import SelectProvince from '@/components/base/SelectProvince.vue'
import DropdownDatePicker from '@/components/base/DropdownDatePicker.vue'
import RoundButton from '@/components/base/RoundButton.vue'
import RadioButton from '@/components/base/RadioButton.vue'

const mockString = Math.random().toString(36).substring(7)
export default {
  components: {
    Input,
    MaskInput,
    Backbar,
    DropdownDatePicker,
    AnswerList,
    SelectProvince,
    RoundButton,
    RadioButton
  },
  data () {
    return {
      isValidForm: false,
      registration: {
        lineAccessToken: '',
        lineUserId: '',
        lineDisplayName: '',
        linePictureUrl: '',
        lineStatusMessage: '',
        firstName: '',
        lastName: '',
        birthDate: '',
        mobile: '',
        address: '',
        province: '',
        district: '',
        subDistrict: '',
        postCode: '',
        gender: ''
      },

      // question
      questionHealthProblemsId: null,
      questionHealthInterestingId: null,

      healthProblems: [],
      healthInteresting: [],

      isOtherHealthProblem: false,
      isOtherHealthInteresting: false,

      otherHealthProblem: '',
      otherHealthInteresting: '',

      // address select
      provinceId: null,
      districtId: null,
      subDistrictId: null,

      errorMessage: ''
    }
  },
  computed: {
    ...mapState('Auth', ['event', 'user']),
    provinces () {
      return jsonProvinces
    },
    districts () {
      if (this.provinceId === null) {
        return []
      }
      const data = jsonDistricts
        .filter(n => {
          return n.province_id === this.provinceId.toString() && !(n.name_th.includes('*') || n.name_en.includes('*'))
        })
      return data
    },
    subDistricts () {
      if (this.districtId === null) {
        return []
      }
      const data = jsonSubDistricts.filter(n => {
        return n.amphure_id === this.districtId.toString() && !(n.name_th.includes('*') || n.name_en.includes('*'))
      })
      return data
    }
  },
  watch: {
    registration: {
      deep: true,
      handler: function () {
        // this.updateFormValidity()
      }
    },
    healthProblems: function (newValue) {
      const otherAns = newValue.find((obj) => obj.is_other)
      this.isOtherHealthProblem = otherAns.is_check
      if (!this.isOtherHealthProblem) {
        this.otherHealthProblem = ''
      } else {
        this.otherHealthProblem = otherAns.other
      }
      // this.updateFormValidity()
    },
    healthInteresting: function (newValue) {
      const otherAns = newValue.find((obj) => obj.is_other)
      this.isOtherHealthInteresting = otherAns.is_check
      if (!this.isOtherHealthInteresting) {
        this.otherHealthInteresting = ''
      } else {
        this.otherHealthInteresting = otherAns.other
      }
      // this.updateFormValidity()
    },
    otherHealthProblem: function () {
      // this.updateFormValidity()
    },
    otherHealthInteresting: function () {
      // this.updateFormValidity()
    }
  },
  methods: {
    ...mapActions({
      register: 'Auth/register',
      login: 'Auth/login',
      updateLineUser: 'Auth/updateLineUser',
      fetchCustomer: 'Auth/fetchCustomer',
      editCustomer: 'Auth/editCustomer',
      fetchHealthQuestion: 'Auth/fetchUserHealthQuestion',
      fetchInterestQuestion: 'Auth/fetchUserInterestQuestion',
      putHealthQuestion: 'Auth/putHealthQuestion',
      putInterestQuestion: 'Auth/putInterestQuestion'
    }),
    hideKeyboard () {
      document.activeElement.blur()
    },
    onTagHealthProblemChanged (selectedTag) {
      const tags = this.selectedHealthProblems.filter((t) => t.id === selectedTag.id)
      if (tags.length > 0) {
        this.selectedHealthProblems = this.selectedHealthProblems.filter(t => t.id !== selectedTag.id)
      } else {
        this.selectedHealthProblems.push(selectedTag)
      }
    },
    onTagHealthInterestingChanged (selectedTag) {
      const tags = this.selectedHealthInteresting.filter((t) => t.id === selectedTag.id)
      if (tags.length > 0) {
        this.selectedHealthInteresting = this.selectedHealthInteresting.filter(t => t.id !== selectedTag.id)
      } else {
        this.selectedHealthInteresting.push(selectedTag)
      }
    },
    findProvinceById (provinceId) {
      if (!provinceId) {
        return this.provinces[0]
      }
      const data = jsonProvinces
        .find((p) => {
          return provinceId === p.id
        })
      if (data) {
        return data
      }
      return this.provinces[0]
    },
    findDistrictById (districtId) {
      if (!districtId) {
        return this.districts[0]
      }
      const data = jsonDistricts
        .find((d) => {
          return districtId === d.id
        })
      if (data) {
        return data
      }
      return this.districts[0]
    },
    findSubDistrictById (subDistrictId) {
      if (!subDistrictId) {
        return this.subDistricts[0]
      }
      const data = jsonSubDistricts
        .find((s) => {
          return subDistrictId === s.id
        })
      if (data) {
        return data
      }
      return this.subDistricts[0]
    },
    findProvinceByName (provinceName) {
      if (!provinceName) {
        return this.provinces[0]
      }
      const data = jsonProvinces
        .find((p) => {
          return provinceName === p.name_th || provinceName.trim().toLowerCase() === p.name_en.trim().toLowerCase()
        })
      if (data) {
        return data
      }
      return this.provinces[0]
    },
    findDistrictByName (districtName) {
      if (!districtName) {
        return this.districts[0]
      }
      const data = jsonDistricts
        .find((d) => {
          return districtName === d.name_th || districtName.trim().toLowerCase() === d.name_en.trim().toLowerCase()
        })
      if (data) {
        return data
      }
      return this.districts[0]
    },
    findSubDistrictByName (subDistrictName) {
      if (!subDistrictName) {
        return this.subDistricts[0]
      }
      const data = jsonSubDistricts
        .find((d) => {
          return subDistrictName === d.name_th || subDistrictName.trim().toLowerCase() === d.name_en.trim().toLowerCase()
        })
      if (data) {
        return data
      }
      return this.subDistricts[0]
    },
    onProvinceChange () {
      this.districtId = null
      this.subDistrictId = null
      this.registration.district = ''
      this.registration.subDistrict = ''
      this.registration.postCode = ''
      if (this.provinceId !== null) {
        const p = this.findProvinceById(this.provinceId)
        this.registration.province = this.$i18n.locale === 'th' ? p.name_th : p.name_en
      }
    },
    onDistrictChange () {
      this.subDistrictId = null
      this.registration.postCode = ''
      if (this.districtId !== null) {
        const d = this.findDistrictById(this.districtId)
        this.registration.district = this.$i18n.locale === 'th' ? d.name_th : d.name_en
      }
    },
    onSubDistrictChange () {
      if (this.subDistrictId !== null) {
        const s = this.findSubDistrictById(this.subDistrictId)
        this.registration.subDistrict = this.$i18n.locale === 'th' ? s.name_th : s.name_en
        this.registration.postCode = s.zip_code
      }
    },
    async updateFormValidity () {
      const { isValid, errors } = await this.$refs.registerForm.validateWithInfo({
        silent: true
      })
      this.isValidForm = isValid
      console.log('updateFormValidity: ', isValid, errors)
    },
    replaceOtherAnswer (answers, other) {
      return answers.map((obj) => obj.is_other ? { ...obj, other } : { ...obj })
    },
    async submit () {
      this.$wait.start('app loading')
      try {
        const isValid = await this.$refs.registerForm.validate()
        if (!isValid) return
        this.hideKeyboard()
        let lineProfile = null
        let lineAccessToken = null
        if (process.env.NODE_ENV === 'production') {
          lineProfile = await liff.getProfile()
          lineAccessToken = await liff.getAccessToken()
        } else {
          lineProfile = {
            userId: mockString
          }
          lineAccessToken = mockString
        }
        this.registration.lineAccessToken = lineAccessToken || ''
        this.registration.lineUserId = (lineProfile && lineProfile.userId) || ''
        this.registration.lineDisplayName = (lineProfile && lineProfile.displayName) || ''
        this.registration.linePictureUrl = (lineProfile && lineProfile.pictureUrl) || ''
        this.registration.lineStatusMessage = (lineProfile && lineProfile.statusMessage) || ''
        this.registration.address_1 = this.registration.address
        console.log('registration', humps.decamelizeKeys(this.registration))
        await this.editCustomer(humps.decamelizeKeys({
          ...this.registration,
          mobile: this.registration.mobile.replace(/-/g, '')
        }))

        await this.putHealthQuestion({
          ans_choice: JSON.stringify(this.replaceOtherAnswer(this.healthProblems, this.otherHealthProblem)),
          question_id: this.questionHealthProblemsId
        })
        await this.putInterestQuestion({
          ans_choice: JSON.stringify(this.replaceOtherAnswer(this.healthInteresting, this.otherHealthInteresting)),
          question_id: this.questionHealthInterestingId
        })
        await this.fetchCustomer()
        this.$router.push({ name: 'Home' })
      } catch (error) {
        if (error.response && error.response.status === 400) {
          if (error.response.data.email) {
            this.errorMessage = 'email ของท่านได้ถูกใช้งาน กรุณากรอก email ใหม่'
          } else if (error.response.data.mobile) {
            this.errorMessage = 'เบอร์โทรศัพท์ ของท่านได้ถูกใช้งาน กรุณากรอก เบอร์โทรศัพท์ ใหม่'
          } else if (error.response.data.full_name) {
            this.errorMessage = 'ชื่อ-นามสกุล ของท่านได้ถูกใช้งาน กรุณากรอก ชื่อ-นามสกุล ใหม่'
          } else {
            this.errorMessage = error.response.data
          }
        } else {
          this.errorMessage = error.toString()
        }
        this.$buefy.toast.open({
          message: this.errorMessage,
          position: 'is-bottom',
          type: 'is-danger'
        })
      } finally {
        this.$wait.end('app loading')
        window.scrollTo(0, 0)
      }
    }
  },
  created () {
    try {
      // await this.fetchCustomer()
      this.registration.firstName = this.user.first_name
      this.registration.lastName = this.user.last_name
      this.registration.gender = this.user.gender
      this.registration.birthDate = this.user.birth_date

      const formatter = new StringMask('000-000-0000')
      const result = formatter.apply(this.user.mobile)
      this.registration.mobile = result

      this.registration.address = this.user.address_1
      const province = this.findProvinceByName(this.user.province)
      this.province = this.$i18n.locale === 'th' ? province.name_th : province.name_en
      this.provinceId = province.id
      this.registration.province = this.user.province || this.province

      const district = this.findDistrictByName(this.user.district)
      this.district = this.$i18n.locale === 'th' ? district.name_th : district.name_en
      this.districtId = district.id
      this.registration.district = this.user.district || this.district

      const subDistrict = this.findSubDistrictByName(this.user.sub_district)
      this.subDistrict = this.$i18n.locale === 'th' ? subDistrict.name_th : subDistrict.name_en
      this.subDistrictId = subDistrict.id
      this.registration.subDistrict = this.user.sub_district || this.subDistrict

      this.registration.postCode = this.user.post_code
    } catch (e) {

    }
  },
  async mounted () {
    const { ans_choice: problemChoice, question: questionHealthProblems } = await this.fetchHealthQuestion()
    this.healthProblems = problemChoice || []
    this.questionHealthProblemsId = questionHealthProblems.id

    const { ans_choice: interestChoice, question: questionHealthInteresting } = await this.fetchInterestQuestion()
    this.healthInteresting = interestChoice || []
    this.questionHealthInterestingId = questionHealthInteresting.id
  }
}
</script>

<style lang="scss" scoped>
.register-form {
  padding: 0px 36px 36px 36px;
}
</style>
